import React, { Component } from "react";

class LogTable extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { headings, data } = this.props;

        return (
        <table className="table table-itemList table-logList">
            <thead>
                <tr>
                    {headings.map((title, index) => <th key={index}>{title}</th>)}
                </tr>
            </thead>
            <tbody>
            {data.map((row, rowIndex) => {
                return (
                <tr key={rowIndex}>
                    {headings.map((column, columnIndex) => {
                            return (
                                
                                <td key={columnIndex} dangerouslySetInnerHTML={{ __html: row[columnIndex]}}></td>

                                
                            );
                        })
                    }
                </tr>
                );
            })}
            </tbody>
        </table>
        );
    }
}

export default LogTable;